import { Student } from "./student";
import { Moment } from "moment";
import { SystemUser } from './system-user';
import { School } from './school';
import { PaymentReceived } from './payment-received';
import { PaymentToSupplier } from './payment-to-supplier';
import { Country } from './country';
import { LanguageCourse } from './language-course';
import { InternalBookingComment } from './internal-booking-comment';
import { TargetLanguageLevel } from './target-language-level';
import { Accommodation } from './accommodation';
import { Travel } from './travel';
import { SalesAgent } from './sales-agent';
import { BookingQuotation } from './booking-quotation';
import { TransferType } from "./transfer-type";
import { ProgrammeType } from "./programme-type";
import { BookingPreConfirmation } from "./booking-pre-confirmation";
import { TravelRequestCode } from "./travel-request-code";
import { SchoolInvoiceWithPaymentOrders } from "./school-invoice-with-payment-orders";
import { InsuranceSupplier } from "./insurance-supplier";
import { BookingType } from "./booking-type.enum";
import { BookingHighSchoolInfo } from "./booking-high-school-info";
import { BookingImmersionInfo } from "./booking-immersion-info";

export class Booking{

    public programmeType?: ProgrammeType;
    public paymentReceivedList!: PaymentReceived[];
    public schoolInvoiceList!: SchoolInvoiceWithPaymentOrders[];
    public paymentToSupplierList!: PaymentToSupplier[];
    public cancellationInsuranceSubscriptionDate!: Moment | null;
    public bookingType?: BookingType;
    public highSchoolInfo?: BookingHighSchoolInfo | null;
    public immersionInfo?: BookingImmersionInfo;
    public lastModified?: Moment | null;
    
    constructor(
        public startDate: Moment,
        public endDate: Moment,
        public isActive: boolean,
        public school: School,
        public preConfirmation: BookingPreConfirmation | null,
        public destination: Country,
        public languageCourse: LanguageCourse,
        public commentToSchool: string,
        public internalCommentList: InternalBookingComment[],
        public targetLanguageLevel: TargetLanguageLevel,
        public accommodation: Accommodation,
        public travels: Travel[],
        public student: Student,
        public sentToSchool: Moment | null,
        public schoolConfirmed: Moment | null,
        public preConfirmationSent: Moment | null,
        public insuranceSent: Moment | null,
        public salesAgent: SalesAgent,
        public quotationList: BookingQuotation[],
        public transferType: TransferType,
        public enableAccommodationDates: boolean,
        public courseComment: string,
        public activitiesComment: string,
        public excursionDate: Moment | null,
        public promoCode: string,
        public highSchoolMeetingDate: Moment | null,
        public highSchoolTestScore: string,
        public flightRequested: boolean,
        public cancellationInsuranceRequested: boolean,
        public travelInsuranceRequested: boolean,
        public depositReceived: Moment | null,
        public completePaymentReceived: Moment | null,
        public accommodationSent: Moment | null,
        public travelInformationSent: Moment | null,
        public flightBookedDate: Moment | null,
        public visaInformationSent: Moment | null,
        public finalConfirmationSent: Moment | null,
        public bookingConfirmed: Moment | null,
        public travelRequestCode: TravelRequestCode,
        public emergencyTransferPhoneNumber: string,
        public travelInsuranceSupplier: InsuranceSupplier,
        public cancellationInsuranceSupplier: InsuranceSupplier | null,
        public emergencyTransferContact: string,
        public versionId: number,
        public reminderDate: Moment | null,
        public withPartena: boolean,
        public uuid?: string,
        public id?: number,
        public duration?: number,
        public downloading?: boolean,
        public createdBy?: SystemUser,
        public created?: Moment | null,
        public studentPicture?: Blob | null,
        public ageAtStartDate?: number,
        public lvmsId?: number
    ){}
}